export default "<p>recorrido-resumen-small works!</p>\n"